import { useEffect, useState } from "react";
import Card from "../Card/Card";
import classes from "./Refer.module.css";
import CopyIcon from "../../icon/CopyIcon";
import { InfoContainer } from "../Trading/components/AccountDetails/AccountDetails";
import RequestPayout from "../Trading/components/RequestPayout/RequestPayout";
import { env } from "../../constants/env";
import { useUser } from "../../context/UserContext";
import axios from "axios";
import { toast } from "react-toastify";
import UserMultipleIcon from "../../icon/UserMultipleIcon";

const historyData = [
  {
    date: "2023-11-24",
    email: "username@email.com",
    status: "Free",
    amount: "$0.00",
  },
  {
    date: "2023-11-24",
    email: "username@email.com",
    status: "Paid",
    amount: "$100.00",
  },
  {
    date: "2023-11-24",
    email: "username@email.com",
    status: "Paid",
    amount: "$100.00",
  },
  {
    date: "2023-11-24",
    email: "username@email.com",
    status: "Paid",
    amount: "$100.00",
  },
  {
    date: "2023-11-24",
    email: "username@email.com",
    status: "Paid",
    amount: "$100.00",
  },
  {
    date: "2023-11-24",
    email: "username@email.com",
    status: "Paid",
    amount: "$100.00",
  },
];

const Refer = () => {
  const [copyStatus, setCopyStatus] = useState("");

  const [withdraw, setWithdraw] = useState(false);
  const [withdrawalSuccess, setWithdrawalSuccess] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCommissions, setTotalCommissions] = useState(0);
  const [referrals, setReferrals] = useState([]);
  const [ranks, setRanks] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(10);

  const { user } = useUser();

  const handleCopy = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopyStatus("Text copied!");
      toast.success("Link copied!");
    } catch (err) {
      console.error("Failed to copy text: ", err);
      setCopyStatus("Failed to copy text.");
    }
  };

  const stats = [
    {
      title: "Referrals",
      number: ranks,
    },
    {
      title: "Balance",
      number: `$${totalCommissions}`,
    },
  ];

  useEffect(() => {
    const fetchReferralsAndCommissions = async () => {
      setError(null);
      try {
        const response = await axios.get(`${env.apiUrl}/api/referrals`, {
          params: { page: currentPage, limit },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        });

        const mappedReferrals = response.data.referrals.map((ref) => ({
          date: new Date(ref.referralDate).toLocaleDateString(),
          email: ref.referredEmail,
          status: ref.status,
          cohort: ref.cohort || "-",
          earned: `$${Number(ref.earned).toFixed(2)}`,
          payout: ref.payout || "Pending",
        }));

        setReferrals(mappedReferrals);
        setTotalPages(response.data.totalPages);
        setRanks(response.data.ranks);

        const commissionsResponse = await axios.get(
          `${env.apiUrl}/api/referrals/commissions/total`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        setTotalCommissions(commissionsResponse.data.total);
      } catch (err) {
        setError(err.response?.data?.error || "Error fetching data");
      }
    };

    fetchReferralsAndCommissions();
  }, [currentPage, limit]); // <- add limit here

  return (
    <div className={classes.wrapper}>
      <div className="d-flex flex-column align-items-center gap-5">
        <div className={classes.titleSection}>
          <h1>Refer & Earn</h1>
          <h3>
            Get <span>$7</span> per trader you refer to the free challenge.
          </h3>
        </div>
        <div className={classes.statsSection}>
          <Card className={`${classes.cardWrapper} d-flex flex-column gap-4`}>
            <h3>Share your referral link</h3>
            <InfoContainer
              className={`${classes.inputInfo}`}
              textIconStyle={classes.textIconStyle}
              name={`${env.siteUrl}?referral-code=${user?.referralCode}`}
              text="Share"
              icon={
                <CopyIcon
                  color="#30970B"
                  onClick={() =>
                    handleCopy(
                      `${env.siteUrl}?referral-code=${user?.referralCode}`
                    )
                  }
                />
              }
            />
          </Card>
          <div className={classes.statsWrapper}>
            <div className={`d-flex gap-3 my-4 ${classes.statsRow}`}>
              {stats.map((item, i) => (
                <Card
                  className={`d-flex flex-column align-items-center justify-content-center ${classes.statsCard}`}
                  key={i}
                >
                  <h5>{item.title}</h5>
                  <h3>{item.number}</h3>
                  {i === stats.length - 1 && (
                    <div
                      className={classes.withdrawalButton}
                      role="button"
                      onClick={() =>
                        !withdraw && !withdrawalSuccess && setWithdraw(true)
                      }
                      style={{
                        cursor:
                          totalCommissions < 50 || new Date().getDate() !== 18
                            ? "not-allowed"
                            : "pointer",
                        opacity:
                          totalCommissions < 50 || new Date().getDate() !== 18
                            ? 0.5
                            : 1,
                      }}
                    >
                      Withdraw
                    </div>
                  )}
                </Card>
              ))}
            </div>
          </div>
          <p>
            Earn $5 per referral ($7 if they trade within 7 days) with a $50
            minimum withdrawal available on the 18th of each month.
          </p>
        </div>
      </div>

      <div className={`mt-5 ${classes.historySection} container`}>
        <h2>
          {withdraw || withdrawalSuccess ? "Withdraw" : "Referral history"}
        </h2>
        {withdraw && !withdrawalSuccess && (
          <RequestPayout
            refer={true}
            profitAmount={totalCommissions}
            setWithdrawalSuccess={(value) => {
              setWithdraw(false);
              setWithdrawalSuccess(value);
            }}
          />
        )}
        {!withdraw && !withdrawalSuccess && (
          <>
            <Card
              className={`${classes.historyCard} ${
                referrals.length === 0 ? classes.emptyHistory : ""
              }`}
            >
              {/* Desktop Table */}
              <div className={classes.desktopTable}>
                <table className={classes.table}>
                  <thead>
                    <tr>
                      <th className={classes.th}>Referral date</th>
                      <th className={classes.th}>Referral email</th>
                      <th className={classes.th}>Referral status</th>
                      <th className={classes.th}>Cohort</th>
                      <th className={classes.th}>Earned</th>
                      <th className={classes.th}>Payout</th>
                    </tr>
                  </thead>
                  <tbody>
                    {referrals.map((item, index) => (
                      <tr key={index}>
                        <td className={classes.td}>{item.date}</td>
                        <td className={classes.td}>{item.email}</td>
                        <td className={classes.td}>{item.status}</td>
                        <td className={classes.td}>{item.cohort}</td>
                        <td className={classes.td}>{item.earned}</td>
                        <td
                          className={`${classes.td} ${
                            item.payout === "Pending"
                              ? classes.payoutPending
                              : item.payout === "Paid"
                              ? classes.payoutPaid
                              : ""
                          }`}
                        >
                          {item.payout}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile Card View */}
              <div className={classes.mobileTable}>
                {referrals.map((item, index) => (
                  <div key={index} className={classes.mobileRow}>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className={classes.email}>{item.email}</p>
                        <div className={classes.rowDetails}>
                          <span>{item.date}</span> • <span>{item.status}</span>{" "}
                          •{" "}
                          <span
                            className={
                              item.payout === "Pending"
                                ? classes.payoutPending
                                : item.payout === "Paid"
                                ? classes.payoutPaid
                                : ""
                            }
                          >
                            {item.payout}
                          </span>
                        </div>
                      </div>
                      <div className={classes.bottomRow}>
                        <div className={classes.earned}>{item.earned}</div>
                        <div>{item.cohort}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Card>
            <div className="my-4 d-flex justify-content-md-end justify-content-center">
              <div className={classes.paginationWrapper}>
                <button
                  className={`${classes.pageButton} ${classes.prevNext}`}
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                >
                  Prev
                </button>

                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  return (
                    <button
                      key={page}
                      className={`${classes.pageButton} ${
                        currentPage === page ? classes.activePage : ""
                      }`}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  );
                })}

                <button
                  className={`${classes.pageButton} ${classes.prevNext}`}
                  disabled={currentPage === totalPages}
                  onClick={() =>
                    setCurrentPage((p) => Math.min(p + 1, totalPages))
                  }
                >
                  Next
                </button>

                <div className={classes.resultPerPage}>
                  Result per page
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(Number(e.target.value)); // update limit
                      setCurrentPage(1); // reset to first page
                    }}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                </div>
              </div>
            </div>
          </>
        )}
        {!withdraw && withdrawalSuccess && (
          <div className="d-flex align-items-center justify-content-center">
            <div
              className={`d-flex flex-column align-items-center justify-content-center ${classes.successContainer}`}
            >
              <img src="/targets.svg" />
              <p>Your withdrawal request has been submitted successfully!</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Refer;
